/**
 * Enumeration of translation keys used in the application.
 */
export enum TranslateKey {
  TITLES = 'titles',
  FORBIDDEN = 'forbidden',
  MESSAGES = 'messages',
  CONTRACTS = 'contracts',
  LANGUAGES = 'languages',
  FOLDERS = 'folders',
  PRIME_NG_TRANSLATE = 'primeNg',
  HOME_TITLE = 'forms.titles.home',
  DASHBOARD_TITLE = 'forms.titles.dashboard',
  REQUESTS_TITLE = 'forms.titles.requests',
  CONTRACTS_TITLE = 'forms.titles.contracts',
  CONTRACT_TITLE = 'forms.titles.contract',
  MODELS_TITLE = 'forms.titles.models',
  EMPLOYEES_TITLE = 'forms.titles.employees',
  SETTINGS_TITLE = 'forms.titles.settings',
  NOT_FOUND_TITLE = 'notFound.titles.notFoundTitle',
  LAST_UPDATE_TITLE = 'forms.titles.lastUpdate',
  PROFILE_TITLE = 'forms.titles.profile',
  MY_AVATAR = 'forms.titles.myAvatar',
  COUNTRY_CONFIGURATION_TITLE = 'forms.titles.countryConfiguration',
  ELECTRONIC_SIGNATURE_TITLE = 'forms.titles.electronicSignature',
  SIGNATURE_TITLE = 'forms.titles.signature',
  NEW_FILE_TITLE = 'forms.titles.newFile',
  ANNEXES_TITLE = 'forms.titles.annexes',
  ANNEXED_DOCUMENT_TITLE = 'forms.titles.annexedDocuments',
  ACTION_TITLE = 'forms.titles.actions',
  FILLING_TITLE = 'forms.titles.filling',
  ASSIGNATION_TITLE = 'forms.titles.assignment',
  DOCUMENT_TITLE = 'forms.titles.document',
  FOLDER_TITLE = 'forms.titles.folder',
  ITEM_TITLE = 'forms.titles.item',
  NOT_ASSIGN_TITLE = 'forms.titles.notAssign',
  UNKNOWN_TITLE = 'forms.titles.unknown',
  UNKNOWN_LABEL_TITLE = 'forms.titles.unknownLabel',
  CHOICE_TITLE = 'forms.titles.choice',
  PERSONALIZATION_TITLE = 'forms.titles.personalization',
  INVOLVED_PEOPLE_TITLE = 'forms.titles.involvedPeople',
  INVOLVED_PEOPLES_TITLE = 'forms.titles.involvedPeoples',
  DESCRIPTION_TITLE = 'forms.titles.description',
  INVOLVED_EMPLOYEE_LIST_TITLE = 'forms.titles.involvedEmployeeList',
  INVOLVED_EMPLOYEE_TITLE = 'forms.titles.involvedEmployee',
  DELETE_IMPOSSIBLE_TITLE = 'forms.titles.deleteImpossible',
  RETRIEVAL_IMPOSSIBLE_TITLE = 'forms.titles.retrievalImpossible',
  SECTIONS_TITLE = 'forms.titles.sections',
  REMINDERS_TITLE = 'forms.titles.reminders',
  OTHER_TITLE = 'forms.titles.others',
  MODEL_CHOICE = 'forms.titles.modelChoice',
  CONTRACT_DETAILS = 'forms.titles.contractDetails',
  CONTRACT_CUSTOMIZATION_TITLE = 'forms.titles.contractCustomization',
  CONFIRMATION = 'forms.titles.confirmation',
  PLANNING = 'forms.titles.planning',
  LABEL_TITLE = 'forms.titles.label',
  MONTH_TITLE = 'forms.titles.month',
  BEFORE_TITLE = 'forms.titles.before',
  AFTER_TITLE = 'forms.titles.after',
  DAY_TITLE = 'forms.titles.day',
  TRIAL_PERIOD_TITLE = 'forms.titles.trialPeriod',
  AT_TITLE = 'forms.titles.at',
  OR_TITLE = 'forms.titles.or',
  SIGNATORY_TITLE = 'forms.titles.signatory',
  MISSING_INFORMATION_TITLE = 'forms.titles.missingInformation',
  ATTENTION_TITLE = 'forms.titles.attention',
  YES_TITLE = 'forms.titles.yes',
  NO_TITLE = 'forms.titles.no',
  IMPORTANT_TITLE = 'forms.titles.important',
  NOT_FOUND_PAGE_MESSAGE = 'notFound.messages.pageNotFound',
  EMPTY_DEFAULT_MESSAGE = 'messages.emptyDefault',
  ERROR_PDF_DOCUMENT_NOT_ALLOWED = 'messages.errors.pdfDocumentNotAllowed',
  EMPTY_SECTION_DOCUMENT = 'requests.messages.emptyDocumentSection',
  NOT_AVAILABLE_DOCUMENT = 'requests.messages.notAvailableDocument',
  LOADING = 'messages.loading',
  LOADING_CONTENT = 'messages.loadingContent',
  SEALING_IN_PROGRESS = 'messages.sealingInProgress',
  NO_ANNEXED_DOCUMENT = 'messages.noAnnexedDocument',
  ERROR_OCCUR = 'messages.errors.occur',
  ERROR_LOGOUT = 'messages.errors.logout',
  ERROR_ACCESS_DENIED = 'messages.errors.accessDenied',
  ERROR_WORD_DOCUMENT_ALLOWED = 'messages.errors.wordDocumentAllowed',
  ERROR_ZIP_DOCUMENT_NOT_ALLOWED = 'messages.errors.zipDocumentNotAllowed',
  ERROR_NOT_FOUND = 'messages.errors.notFound',
  ERROR_DOWNLOAD_DOCUMENT = 'messages.errors.downloadDocument',
  ERROR_HISTORY_DATA_NOT_VALID = 'messages.errors.historyDataNotValid',
  ERROR_UPLOADING_FILE = 'messages.errors.uploadingFile',
  ERROR_PAYROLL_PERMISSION_DENIED = 'messages.errors.payrollPermissionDenied',
  VALIDATION_REQUIRED_SELECTED_VARIABLES = 'messages.validations.required.selectedVariable',
  VALIDATION_REQUIRED_SELECTED_FOLDER = 'messages.validations.required.selectedFolder',
  TOAST_SUCCESS = 'forms.toasts.success',
  TOAST_ERROR = 'forms.toasts.error',
  TOAST_WARNING = 'forms.toasts.warning',
  TOAST_INFO = 'forms.toasts.info',
  TOAST_LOADING = 'forms.toasts.loading',
  ACTION_FILTER_BY = 'forms.actions.filterBy',
  BUTTON_SEARCH = 'forms.buttons.search',
  BUTTON_NEW_FILE = 'forms.buttons.newFile',
  BUTTON_BACKUP = 'forms.buttons.backup',
  BUTTON_CONFIGURE = 'forms.buttons.configure',
  BUTTON_SAVE = 'forms.buttons.save',
  BUTTON_GENERATE = 'forms.buttons.generate',
  BUTTON_SIGN = 'forms.buttons.sign',
  BUTTON_SIGN_REQUEST = 'forms.buttons.signRequest',
  BUTTON_CANCEL = 'forms.buttons.cancel',
  BUTTON_PREVIOUS = 'forms.buttons.previous',
  BUTTON_DELETE = 'forms.buttons.delete',
  BUTTON_SEND = 'forms.buttons.send',
  BUTTON_FILL = 'forms.buttons.fill',
  BUTTON_COMPLETE = 'forms.buttons.complete',
  BUTTON_SAVE_DRAFT = 'forms.buttons.saveDraft',
  BUTTON_IGNORE_CONTINUE = 'forms.buttons.ignoreContinue',
  BUTTON_CONTINUE = 'forms.buttons.continue',
  BUTTON_DOWNLOAD = 'forms.buttons.download',
  BUTTON_GO_BACK = 'forms.buttons.goBack',
  BUTTON_GO_BACK_HOME = 'forms.buttons.goBackHome',
  BUTTON_SEE_PROFILE = 'forms.buttons.seeProfile',
  BUTTON_ASSIGN_DOCUMENT = 'forms.buttons.assignDocument',
  BUTTON_ASSIGN = 'forms.buttons.assign',
  BUTTON_ADD_DOCUMENT = 'forms.buttons.addDocument',
  BUTTON_RELAUNCH = 'forms.buttons.relaunch',
  BUTTON_DISPLAY = 'forms.buttons.display',
  BUTTON_NEW = 'forms.buttons.new',
  BUTTON_NEW_MODEL = 'models.forms.titles.newModel',
  BUTTON_VISUALIZE = 'forms.buttons.visualize',
  BUTTON_CHOOSE = 'forms.buttons.choose',
  BUTTON_NEXT = 'forms.buttons.next',
  BUTTON_OPEN = 'forms.buttons.open',
  BUTTON_EDIT = 'forms.buttons.edit',
  BUTTON_RENAME = 'forms.buttons.rename',
  BUTTON_CLOSE = 'forms.buttons.close',
  BUTTON_GRID = 'forms.buttons.grid',
  BUTTON_LIST = 'forms.buttons.list',
  BUTTON_VALID = 'forms.buttons.valid',
  BUTTON_IMPORT_FILE = 'forms.buttons.importFile',
  BUTTON_PLAN_LATER = 'forms.buttons.scheduleLater',
  BUTTON_SEND_OR_SIGN = 'forms.buttons.sendOrSign',
  BUTTON_SAVE_AND_SIGN = 'forms.buttons.saveAndSign',
  BUTTON_FILL_MISSING_INFORMATION = 'forms.buttons.fillMissingInformation',
  BUTTON_EDIT_ANYWAY = 'forms.buttons.editAnyway',
  BUTTON_DO_NOT_SHOW_AGAIN = 'forms.buttons.doNotShowAgain',
  BUTTON_CONFIGURE_NOW = 'forms.buttons.configureNow',
  BUTTON_ADD_NEW_FOLDER = 'forms.buttons.addNewFolder',
  BUTTON_ADD_SUB_FOLDER = 'forms.buttons.addNewSubFolder',
  BUTTON_GO_BACK_WORKSPACE = 'forms.buttons.goBackWorkspace',
  BUTTON_ADD_DESCRIPTION = 'forms.buttons.addDescription',
  BUTTON_SHOW_DESCRIPTION = 'forms.buttons.showDescription',
  BUTTON_DO_LATER = 'forms.buttons.doLater',
  BUTTON_ASSIGN_NOW = 'forms.buttons.assignNow',
  BUTTON_SAVE_CHANGES = 'forms.buttons.saveChanges',
  FORBIDDEN_RESOURCE_STATUS = 'forbidden.status.resource',
  TOP_BAR_LOGOUT = 'topBar.logout',
  FIELD_NUMBER_PLACEHOLDER = 'forms.field.number.placeholder',
  FIELD_SELECT_PLACEHOLDER = 'forms.field.select.placeholder',
  FIELD_SELECT_COMPANY_PLACEHOLDER = 'forms.field.company.selectPlaceholder',
  FIELD_SELECT_EMPLOYE_PLACEHOLDER = 'forms.field.employe.selectPlaceholder',
  FIELD_DATE_FORMAT = 'forms.field.date.format',
  FIELD_SELECTED_FOLDER_LABEL = 'forms.field.selectedFolder.label',
  FIELD_SELECTED_VARIABLE_PLACEHOLDER = 'forms.field.selectedVariable.placeholder',
  FIELD_SELECT_CONTRACT_TYPE_LABEL = 'forms.field.selectedContractType.label',
  FIELD_ZIP_FILE_IMPORT_LABEL = 'forms.field.zipFileImport.label',
  FIELD_ZIP_FILE_IMPORT_PLACEHOLDER = 'forms.field.zipFileImport.placeholder',
  FIELD_DOCUMENT_IMPORT_LABEL = 'forms.field.documentImport.label',
  ENUM_CONTRACT_TYPE = 'enums.contractType',
  ENUM_IDENTIFICATION_TYPE = 'enums.identificationType',
  ENUM_VARIABLE_TYPE = 'enums.variableType',
  ENUM_FREQUENCY = 'enums.frequency',
  ENUM_REMINDER_MOMENT = 'enums.reminderMoment',
  ENUM_PROFILES = 'enums.profiles',
  ENUM_SECTION = 'enums.sections',
  ENUM_FOLDER_NAME = 'enums.folders',
  ENUM_MODEL_TYPE = 'enums.modelType',
  ENUM_REQUEST_ORIGIN = 'enums.requestOrigin',
  ENUM_REQUEST_DETAIL_STATE = 'enums.requestDetailState',
  PERSONS_TO_NOTIFY = 'forms.titles.persons_to_notify',
  PERSONS_TO_NOTIFY_PLACEHOLDER = 'forms.titles.persons_to_notify_placeholder',
  REQUEST_TRACKING = 'requests.forms.buttons.requestTracking',
  SIGN_REQUEST = 'requests.forms.buttons.signRequest',
  DELETED_DOCUMENT = 'messages.deletedDocumentToast',
  ERROR_ON_DELETED = 'messages.errors.occurOnDelete',
  REMOVE_NOT_EMTY_SECTION_MESSAGE = 'messages.notEmptySection',
  CHOOSE_SECTION_LABEL = 'sections.forms.chooseLabel',
  EMPTY_RESULTS = 'sections.forms.emptyResults',
  OTHER_ELEMENTS = 'sections.forms.otherElements',
  EMPLOYEE_INCOMPLETE_DOCUMENTS = 'employees.incompleteDocuments',
  EMPLOYEE_UPLOAD_INDICATOR = 'employees.uploadIndicator',
  DOCUMENTS_TRANSFERT_TITLE = 'messages.documentTransfertTitle',
  DOCUMENTS_TRANSFERT_MESSAGE = 'messages.documentTransfertMessage',
  DOCUMENTS_TRANSFERT_COMPLIANCES = 'messages.documentTransfertCompliances',
  DATATABLE_ENTRIES = 'forms.titles.table_entries',
  PROFILE_PICTURE = 'forms.titles.profilePicture',
  PROFILE_PICTURE_CHANGED = 'forms.titles.profilePictureChanged',
  PAYSLIP_TITLE = 'payslip.title',
  PAYSLIP_DETAILS = 'payslip.payslipDetails',
}
